const fields = [

  {
    isSystem: true,
    isActive: true,
    editable: false,
    widget: 'DATE_PICKER',
    form: [],
    rules: [{'rule': 'REQUIRED'}],
    key: 'startDate',
    dataType: 'DATE',
    options: []
  },
  {
    isSystem: true,
    isActive: true,
    editable: false,
    widget: 'DATE_PICKER',
    form: [],
    rules: [{'rule': 'REQUIRED'}],
    key: 'endDate',
    dataType: 'DATE',
    options: []
  },
  {
    dataType: 'FILE',
    editable: true,
    form: [],
    isActive: true,
    isSystem: true,
    key: 'certification',
    options: [],
    rules: [{rule: 'REQUIRED'}],
    widget: 'FILES',
  }
];

export {
  fields
};
